import React, { useEffect, useRef, useState } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";

// Displays an odds value that flashes green (up) / red (down) when it changes.
export default function Odds({ value, className = "", showArrow = false }) {
  const prev = useRef(value);
  const [dir, setDir] = useState(null); // 'up' | 'down' | null
  const [flash, setFlash] = useState(false);

  useEffect(() => {
    if (prev.current !== value) {
      const d = value > prev.current ? "up" : "down";
      setDir(d);
      setFlash(true);
      prev.current = value;
      const t = setTimeout(() => setFlash(false), 900);
      return () => clearTimeout(t);
    }
  }, [value]);

  return (
    <span className={`inline-flex items-center gap-0.5 rounded px-1 tabular-nums ${flash ? (dir === "down" ? "odds-flash-down" : "odds-flash-up") : ""} ${className}`}>
      {Number(value).toFixed(2)}
      {showArrow && flash && dir === "up" && <ChevronUp className="h-3.5 w-3.5 text-emerald-400" />}
      {showArrow && flash && dir === "down" && <ChevronDown className="h-3.5 w-3.5 text-red-400" />}
    </span>
  );
}
